// Compatibility shim for `import "./auth"` paths.
export * from "./auth/index";
